import { Organization } from '../organization-types';
import OrgInfoStore from '../stores/org-info-store';

export const setOrgInfo = (orgInfo: Organization) => {
  OrgInfoStore.organization = orgInfo;
};
